/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Member API
 * API for Catch Member Backend
 * OpenAPI spec version: 1.0.0
 */

export type ScreeningDtoStatus = typeof ScreeningDtoStatus[keyof typeof ScreeningDtoStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScreeningDtoStatus = {
  completed: 'completed',
  deleted: 'deleted',
  surfaced: 'surfaced',
} as const;
